export default __webpack_public_path__ + "static/media/azuki.a80fe8bf.png";